<template>
    <div style="display: flex;flex-direction: column; gap: 10px; width: 243px">
        <div :class="{blue: blue, purple: purple}" class="bar">
            <DropdownMenu :icon="micImage" :blue="blue" :purple="purple"
                @input="audio.set($event)" :value="localDeviceID" :choices="localDevices" v-if="localDevices" style="flex: 1"/>
            <img src="../assets/pause.svg" v-if="audio.mediaStream" @click="pauseEvt" style="width: 28px; cursor: pointer">
            <img src="../assets/play.svg" v-else @click="playEvt" style="width: 28px; cursor: pointer">
        </div>
        <div style="border:2px solid black; border-radius: 0; padding: 0; position: relative;">
            <AudioCanvas :data="data" :dataLength="240" :width="240" :reverse="reverse"/>
            <slot />
        </div>
        <div style="display: flex; gap: 8px; align-items: center;"> 
            Classify every
            <DropdownMenu2 style="width: 80px; position: relative;" :blue="blue" :purple="purple"
                @input="snapshotDuration = $event"
                :choices="snapshotDurations"
                :value="snapshotDuration"
            />

            second
        </div>
    </div>
</template>

<script>
import AudioCanvas from '@/tm/AudioCanvas.vue'
import DropdownMenu from '@/ui/DropdownMenu'
import DropdownMenu2 from '@/ui/DropdownMenu2'
import { ref, watchEffect } from 'vue';
import Audio from '../scripts/audio.js'
import { watchObjProp } from '../../../utils/index.js'
import micImage from '../assets/mic.png'
import { reverse } from '@tensorflow/tfjs';

export default {
    name: 'Audio',
    emits: ['update', 'play', 'stop'],
    props: {
        blue: {
            type: Boolean,
            default: false
        },
        purple: {
            type: Boolean,
            default: false
        },
        audio: {
            type: Audio,
            default: new Audio(),
        },
        reverse: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            data: ref([]),
            result: [],
            localDeviceID: null,
            localDevices: null,
            micImage: micImage,
            snapshotDurations: [0.25, 0.5, 0.75, 1],
            snapshotDuration: 0.5,
        }
    },
    components: {
        AudioCanvas,
        DropdownMenu,
        DropdownMenu2
    },
    mounted: async function(){
        watchObjProp(this.audio, 'deviceId', (newValue) => {
            this.localDeviceID = newValue;
        })

        watchObjProp(this.audio, 'devices', (newValue) => {
            this.localDevices = newValue;
        })

        let snapshotCounter = 0;
        this.audio.listen((freqData, freqDataFloat) => {
            this.data.push(Math.max(...freqData))
            this.result.push(freqData)

            if (this.result.length > 43) {
                this.result.shift()
            } 

            if (this.data.length > 240) {
                this.data.shift()
            }

            snapshotCounter++;
            if (snapshotCounter >= this.snapshotDuration * 43 && this.result.length == 43) {
                this.$emit('update', this.result)
                snapshotCounter = 0;
            }
        })
    },
    methods: {
        playEvt(){
            this.audio.resume();
            this.$emit('play')
        },
        pauseEvt(){
            this.audio.stop();
            this.result = []
            this.$emit('stop')
        }
    },
    unmounted(){
        this.audio.stop();
    }
}
</script>

<style scoped>
.onHover{
    opacity: 0.3;
    transition: .3s all ease-in-out;
    position: absolute;
    z-index: 1;
    top: 5px; 
    left: 5px;
}

.onHover:hover{
    opacity: 1;
}

.bar{
    width: 100%; height: max-content; background: #000; 
    padding: 2px; border-radius: 0; z-index: 1; display: flex; justify-content: space-between; gap: 2px;
    position: relative;
}

.bar.blue{
    background: #1967D2;
}

.bar.purple{
    background: #8A66C7;
}

</style>